{
  "RESET_PASSWORD": {
    "TITLE": "비밀번호 재설정하기",
    "DESCRIPTION": "비밀번호 재설정 안내를 받으려면 Chatwoot에 로그인할 때 사용하는 이메일 주소를 입력하십시오.",
    "GO_BACK_TO_LOGIN": "로그인 페이지로 돌아가려면",
    "EMAIL": {
      "LABEL": "이메일",
      "PLACEHOLDER": "이메일을 입력해 주세요.",
      "ERROR": "올바른 이메일 주소를 입력하세요."
    },
    "API": {
      "SUCCESS_MESSAGE": "비밀번호 재설정 링크가 이메일로 전송되었습니다.",
      "ERROR_MESSAGE": "Woot 서버에 연결할 수 없습니다. 나중에 다시 시도해 주세요."
    },
    "SUBMIT": "보내기"
  }
}
